/* eslint camelcase: 0 */
import { Department } from '@/infrastructure/network/Monitaro/schema/models'
import { IDepartmentProps, EmptyDepartmentPropsFactory } from '@/entities/Department'

export const toDepartmentProps = (props: Department | null | undefined): IDepartmentProps => {
  if (!props) {
    return EmptyDepartmentPropsFactory()
  }

  const { id, name, properties, order, created_at, updated_at } = props

  return EmptyDepartmentPropsFactory({
    id,
    name,
    properties,
    order,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
